// Vimeo Player.js for inline iframe control (requires api=1 on embed URL — VimeoBlock.GetIframeUrl).
if (typeof Vimeo === 'undefined') {
    var vimeoSdkScript = document.createElement('script');
    vimeoSdkScript.src = 'https://player.vimeo.com/api/player.js';
    document.head.appendChild(vimeoSdkScript);
}

/** Same markup as OptimizelyVideoBlock / YouTube inline (pause bars vs play triangle). */
var vimeoInlinePauseSvg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">' +
    '<path d="M2 1V14.3333" stroke="#00CC99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M10 1V14.3333" stroke="#00CC99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
var vimeoInlinePlaySvg =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M5 3L12 8L5 13V3Z" fill="currentColor"/>' +
    '</svg>';

jQueryOnReady(function initVimeoInlineControls() {
    if ($('body').hasClass('epi-editMode')) {
        return;
    }

    function initVimeoPlayers() {
        if (typeof Vimeo === 'undefined' || typeof Vimeo.Player === 'undefined') {
            setTimeout(initVimeoPlayers, 100);
            return;
        }

        $('.vimeo-block').each(function () {
            var $container = $(this);
            if ($container.data('vimeo-inline-initialized')) {
                return;
            }

            var $btn = $container.find('.vimeo-block__play-pause-btn');
            var $iframe = $container.find('.vimeo-inline-container iframe');

            if (!$btn.length || !$iframe.length) {
                return;
            }

            // Scope to this block only — duplicate Vimeo IDs on a page must not share one global getElementById.
            var iframe = $iframe[0];
            if (!iframe) {
                return;
            }

            $container.data('vimeo-inline-initialized', true);

            var player = new Vimeo.Player(iframe);

            function setButtonPlayingUi() {
                $btn.html(vimeoInlinePauseSvg).attr({ 'aria-label': 'Pause video', title: 'Pause video' });
            }

            function setButtonPausedUi() {
                $btn.html(vimeoInlinePlaySvg).attr({ 'aria-label': 'Play video', title: 'Play video' });
            }

            player
                .ready()
                .then(function () {
                    return player.getPaused();
                })
                .then(function (paused) {
                    if (paused) {
                        setButtonPausedUi();
                    } else {
                        setButtonPlayingUi();
                    }
                })
                .catch(function () {});

            player.on('play', setButtonPlayingUi);
            player.on('pause', setButtonPausedUi);

            $btn.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                player
                    .getPaused()
                    .then(function (paused) {
                        if (paused) {
                            return player.play();
                        }
                        return player.pause();
                    })
                    .catch(function () {});
            });
        });
    }

    initVimeoPlayers();
});

$('document').ready(function () {
    var $videoModal = $('#video-modal.modal');
    var currVimeoId = '';

    $(document.body).on('click', 'a.is-vimeo', function (e) {
        e.preventDefault();
        var videoId = $(this).attr('data-vimeo-video-id');
        var videoHash = $(this).attr('data-vimeo-hash');
        loadVimeo(videoId, videoHash);
    });

    $videoModal.on('hidden.bs.modal', function (e) {
        var $container = $('#video-modal').find('#modal-player');
        if ($container.length) {
            $container.replaceWith('<div id="modal-player"></div>');
        }
    });

    function loadVimeo(videoId, videoHash) {
        $videoModal.modal();
        playVimeo(videoId, videoHash);
    }

    function playVimeo(id, hash) {
        currVimeoId = id;
        var firstParam = hash ? '?h=' + hash + '&' : '?';
        var vimeoPlayer = $(
            '<iframe id="vimeo-modal-iframe" src="https://player.vimeo.com/video/' +
                id +
                firstParam +
                'title=0&byline=0&portrait=0&muted=1&loop=1&autopause=0&autoplay=1" frameborder="0" allow="autoplay; fullscreen" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'
        );
        $('#video-modal.modal').find('#modal-player').html(vimeoPlayer);
    }
});
